import type React from 'react';
import { ControlCenterPageView } from './ControlCenterPageView';
import { useControlCenter } from './useControlCenter';

/**
 * `/` and `/control-center` — the app's home.
 *
 * Search-first: one field, one grid of pinned actions, and a single quiet
 * catalog of everything else. It is the answer to a manager opening the app
 * with a task in mind rather than a section, and it is the first row of the
 * sidebar for the same reason.
 *
 * **No `ErrorBoundary`, and no skeleton.** The catalog is a fixture in
 * `controlCenterMeta` — there is no endpoint behind these actions yet — so
 * there is nothing in flight to stand in for and nothing beneath this component
 * that can throw. Both come back with the first real read, along with the hook
 * that performs it.
 */
export const ControlCenterPage: React.FC = () => {
    const page = useControlCenter();

    return <ControlCenterPageView page={page} />;
};
